import { StepInstructionGuide } from './step-instruction-guide.js';

export class StepSetupWifiPassword extends StepInstructionGuide {
  id             = 'step_setup_wifi_password';
  title          = 'Set Up a Device';
  previousStepId = 'guide_v2_setup_mode';
  nextStepId     = 'start_app';

  getContent = () => ({
    mainHero: `<div class="onboarding-instruction__hero-placeholder"><img src="${window.site.home}/../assets/images/setup-hero-wifi.png" /></div>`,
    mainHeading: `Next, grab your wifi password`,
    mainBody: `
      <p class="onboarding-guide-instruction">
        You'll need it to connect Temp Stick to your wifi network.
      </p>
    `,
    primaryLabel: `I have my password`,
    helpLabel: `Help me find my password`,
    helpHeading: `How to find your wifi password`,
    helpBody: `
      <ol class="onboarding-guide-instruction">
        <li>Check the sticker on the back or bottom of your router &mdash; many routers have the default wifi name and password printed on a label.</li>
        <li>If you've connected a phone or laptop to this wifi before, you can usually view the saved password in that device's wifi settings.</li>
        <li>Look at the paperwork or welcome email from your internet provider &mdash; the password is often included.</li>
        <li>Ask whoever set up the network, or contact your internet provider if you can't track it down.</li>
      </ol>
    `,
    helpPrimaryLabel: `I have my password`,
  });
}